import React from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Formik } from "formik"

import {
  getFieldValues,
  getSectionFieldNames,
  getSettings,
} from "@/onboarding/features/product/selectors"
import { updateFields } from "@/onboarding/features/product/Slice"
import FormikBootstrap from "@/components/formik-bootstrap"
import { ReservedFields } from "@/onboarding/features/product/models/Product"
import LoadingSpinner from "@/components/LoadingSpinner"
import { useProductSubmitting } from "@/onboarding/features/product/helpers"
import TrackFormDirty from "@/onboarding/features/product/forms/TrackFormDirty"

const Edit = ({ setEditing }): JSX.Element => {
  const fieldNames = useSelector(getSectionFieldNames.tourLocation)
  const initialValues = useSelector(getFieldValues(...fieldNames))
  const fieldsSettings = useSelector(getSettings(...fieldNames))

  const dispatch = useDispatch()
  const [isSubmitting, setSubmitting] = useProductSubmitting()

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values) => {
        setSubmitting(true)
        dispatch(updateFields({ values }))
      }}
    >
      {({ handleSubmit, dirty }) => (
        <Form className="d-flex flex-column gap-3" onSubmit={handleSubmit}>
          <TrackFormDirty formId="tourItineraryOverview" />
          <Row>
            <Col>
              <FormikBootstrap.TextInput
                name={ReservedFields.START_LOCATION}
                label="Start Location"
                readOnly={!fieldsSettings[ReservedFields.START_LOCATION].writeable}
                showLockedIcon={!fieldsSettings[ReservedFields.START_LOCATION].writeable}
                showRequired={fieldsSettings[ReservedFields.START_LOCATION].required}
              />
            </Col>
            <Col>
              <FormikBootstrap.NumberInput
                name={ReservedFields.TOUR_DURATION}
                label="Tour Duration (minutes)"
                readOnly={!fieldsSettings[ReservedFields.TOUR_DURATION].writeable}
                showLockedIcon={!fieldsSettings[ReservedFields.TOUR_DURATION].writeable}
                showRequired={fieldsSettings[ReservedFields.TOUR_DURATION].required}
              />
            </Col>
          </Row>
          <div className="d-flex gap-2">
            <Button size="sm" type="submit" disabled={!dirty || isSubmitting}>
              <i className="fas fa-save me-2" />
              Save
            </Button>
            <Button
              size="sm"
              variant="outline-danger"
              onClick={() => setEditing(false)}
              disabled={isSubmitting}
            >
              <i className="fas fa-times me-2" />
              Cancel
            </Button>
            {isSubmitting && <LoadingSpinner />}
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default Edit
